import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function DashboardSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const borderCls = isDarkMode ? "border-slate-700" : "border-slate-200";
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen w-full ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-7xl mx-auto px-4 py-6 md:py-8">
                    {/* Profile + goals row */}
                    <section className="mb-6 md:mb-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className={`${cardCls} p-6`}>
                            <div className="flex items-center gap-4 mb-4">
                                <Skeleton circle width={64} height={64} />
                                <div className="flex-1">
                                    <Skeleton width="60%" height={20} />
                                </div>
                            </div>
                            <Skeleton count={3} />
                        </div>
                        <div className={`${cardCls} lg:col-span-2 p-6`}>
                            <Skeleton width={160} height={22} className="mb-6" />
                            <div className="space-y-4">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i} className="flex items-center gap-4">
                                        <Skeleton width={90} height={14} />
                                        <div className="flex-1">
                                            <Skeleton height={24} borderRadius={999} />
                                        </div>
                                        <Skeleton width={32} height={14} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* List-style section cards (Action Items, Recommended Jobs, Meetups) */}
                    {Array.from({ length: 3 }).map((_, s) => (
                        <div key={s} className={`${cardCls} mb-6 md:mb-8 overflow-hidden`}>
                            <div className={`px-4 md:px-6 py-4 border-b ${borderCls}`}>
                                <Skeleton width={220} height={24} />
                            </div>
                            <div className="p-4 md:p-6 space-y-3">
                                {Array.from({ length: 4 }).map((_, r) => (
                                    <Skeleton key={r} height={44} borderRadius={8} />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </SkeletonTheme>
    );
}
